import { Button, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import EduNavAppMenu from './EduNavAppMenu'
import EduNavProfileDropdown from './EduNavProfileDropdown'
import EduNavTopbarMenuToggler from './EduNavTopbarMenuToggler'
import { useLayoutContext } from '@/context/useLayoutContext'
import clsx from 'clsx'
import useScrollEvent from '@/hooks/useScrollEvent'
import { useRef } from 'react'
import LogoBox from '../LogoBox'
import useToggle from '@/hooks/useToggle'
import { useAuthContext } from '@/context/useAuthContext'
import AuthModal from '@/app/edunav/auth/AuthModal'
import logo from '@/assets/images/logo.png'
import logoLight from '@/assets/images/logo-light.svg'

const EduNavTopNavigationBar = () => {
  const { appMenuControl } = useLayoutContext()
  const { scrollY } = useScrollEvent()
  const headerRef = useRef(null)

  const { isTrue: isAuthModalOpen, toggle: toggleAuthModal } = useToggle()

  const { isAuthenticated } = useAuthContext()

  return (
    <>
      <header
        ref={headerRef}
        className={clsx('navbar-light navbar-sticky header-static', {
          'navbar-sticky-on': scrollY >= 400,
        })}
      >
        <nav className="navbar navbar-expand-xl">
          <Container className="flex-nowrap">
            {/* LOGO */}
            {/* <LogoBox height={36} width={143} /> */}

 <Link to="/" style={{ textDecoration: 'none' }}>
  <img
    src={logo}
    alt="logo"
    style={{
      height: '110px',
      // width: '140px',
     
      
      padding: '0',
     
   
      filter: `
        drop-shadow(0 0 2px rgba(255, 255, 255, 0.9))
        drop-shadow(0 0 5px rgb(255, 255, 255, 1.7))
        drop-shadow(0 1px 0px rgba(255, 255, 255, 1.4))
      `,
    
    }}
    
  />
</Link>



            {/* Toggler for Mobile */}
            <EduNavTopbarMenuToggler />

            {/* Main navigation menu */}
            <EduNavAppMenu mobileMenuOpen={appMenuControl.open} menuClassName="mx-auto"  toggleMenu={appMenuControl.toggle} />

            {/* Right side navigation items */}
            {/* <div className="navbar-nav ms-2">
              {isAuthenticated ? (
                <EduNavProfileDropdown className="ms-1 ms-lg-0" />
              ) : (
                <Button
                  variant="dark"
                  size="sm"
                  className="mb-0 btn-transition"
                  onClick={toggleAuthModal}
                >
                  Sign In
                </Button>
              )}
            </div> */}
          </Container>
        </nav>
      </header>
      {/* This div is a placeholder to prevent content from jumping when the header becomes sticky */}
      <div
        style={{
          height: scrollY >= 400 ? `${headerRef.current?.offsetHeight}px` : 0,
        }}
      />
      <AuthModal show={isAuthModalOpen} onHide={toggleAuthModal} />
    </>
  )
}

export default EduNavTopNavigationBar
